import { Check, Close } from '@mui/icons-material'

export const State: React.FC<{ active?: boolean }> = ({ active }) => {
  if (active) return <Check />

  return <Close />
}
